import { transformGroupSuggestionsToOptions } from "@/helpers";
import { useSuggestActiveDirectoryQuery } from "@/services";
import { SpaceWithFullWidth } from "@/sharedStyled";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Space, Typography } from "antd";
import { arrayOf, bool, func, shape, string } from "prop-types";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { AutoCompleteInput } from "../AutoCompleteInput";
import { MinusList } from "../MinusList";

const AdGroupSelector = ({
  onAdGroupSelected,
  onAdGroupRemoved,
  existingAdGroups,
  adGroupsLoading,
  cardTitleKey,
  cardSubTitleKey,
  isEmailGroup,
}) => {
  const intl = useIntl();

  const [query, setQuery] = useState();
  const [newAdGroups, setNewAdGroups] = useState([]);
  const [selectedAdGroupId, setSelectedAdGroupId] = useState();

  const { data: adGroupSuggestions, isFetching: adGroupSuggestionsLoading } =
    useSuggestActiveDirectoryQuery(
      { query, isEmailGroup },
      {
        skip: !query,
      }
    );

  useEffect(() => {
    if (existingAdGroups) {
      const existingAdGroupsMapped = existingAdGroups.map(
        ({ id, displayName }) => ({
          id,
          label: displayName,
        })
      );
      setNewAdGroups(existingAdGroupsMapped);
    }
  }, [existingAdGroups]);

  const handleAdGroupSelected = (suggestion) => {
    if (newAdGroups.some(({ id }) => id === suggestion)) return;

    const { document: adGroup } = adGroupSuggestions.find(
      ({ document: { id } }) => id === suggestion
    );
    onAdGroupSelected(adGroup);
    setNewAdGroups([
      ...newAdGroups,
      { id: adGroup.id, label: adGroup.displayName },
    ]);
    setSelectedAdGroupId(adGroup.id);
  };

  const handleGroupRemove = (id) => {
    onAdGroupRemoved(id);
    setNewAdGroups(newAdGroups.filter((adGroup) => adGroup.id !== id));
  };

  return (
    <Card
      title={
        <Space>
          <FontAwesomeIcon icon={faUserPlus} />
          {intl.formatMessage({ id: cardTitleKey })}
        </Space>
      }
      loading={adGroupsLoading}
    >
      <SpaceWithFullWidth direction="vertical" size="small">
        <Typography.Text>
          {intl.formatMessage({ id: cardSubTitleKey })}
        </Typography.Text>
        <AutoCompleteInput
          selectedSuggestionValue={selectedAdGroupId}
          suggestions={transformGroupSuggestionsToOptions(adGroupSuggestions)}
          loading={adGroupSuggestionsLoading}
          onFetchSuggestions={setQuery}
          onInputChange={handleAdGroupSelected}
        />
      </SpaceWithFullWidth>
      <MinusList
        onItemRemove={handleGroupRemove}
        items={newAdGroups?.map(({ id, label }) => ({
          id,
          label,
        }))}
      />
    </Card>
  );
};

AdGroupSelector.propTypes = {
  onAdGroupSelected: func.isRequired,
  onAdGroupRemoved: func.isRequired,
  existingAdGroups: arrayOf(shape({ id: string })),
  adGroupsLoading: bool,
  cardTitleKey: string.isRequired,
  cardSubTitleKey: string.isRequired,
  isEmailGroup: bool,
};

export default AdGroupSelector;
